<template>
    <div class="modal-user-menu modal-mask" @click="hideUserMenu()" v-if="isDisplay">
        <div class="box" :class="isActive ? 'active' : ''" @click.stop>
            <h2>{{ fields.user.firstName }}</h2>
            <div class="list">
                <router-link :to="'/' + $route.params.lang + '/user/profile'" @click.native="hideUserMenu()"><i class="pe-7s-note2"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ประวัติส่วนตัว', 'My Profile') }}</router-link>
                <router-link :to="'/' + $route.params.lang + '/user/account'" @click.native="hideUserMenu()"><i class="pe-7s-tools"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'แก้ไขบัญชี', 'Account Setting') }}</router-link>
                <router-link :to="'/' + $route.params.lang + '/user/certificate'" @click.native="hideUserMenu()"><i class="pe-7s-medal"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ดาวน์โหลดใบรับรอง', 'Download Certificate') }}</router-link>
                <button @click="logout()"><i class="pe-7s-id"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ออกจากระบบ', 'Logout') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isActive: false
        }
    },
    props: {
        isDisplay: Boolean,
        fields: Object
    },
    watch: {
        isDisplay(value) {
            let page = this;

            setTimeout(function () {
                page.isActive = value;
            }, 50);
        }
    },
    methods: {
        hideUserMenu() {
            this.$emit('hideUserMenu');
        },
        logout() {
            this.$cookie.delete('token');
            location.reload();
        }
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.modal-user-menu {
    overflow: hidden;

    .box {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        width: 280px;
        background: #fff;
        padding: 20px;
        @include transformObject(translateX(100%));

        &.active {
            @include transformObject(translateX(0));
        }

        h2 {
            font-size: 20px;
            letter-spacing: -1px;
            color: #333;
            margin: 0;
            padding-bottom: 5px;
            border-bottom: 1px solid $mainColor;
        }

        .list {
            margin-top: 15px;

            a, button {
                text-decoration: none;
                width: 100%;
                display: block;
                font-size: 15px;
                color: #333;
                padding: 15px 0;
                text-align: left;
                outline: none;
                background: none;
                border: none;
                border-bottom: 1px solid #ddd;

                i {
                    width: 20px;
                    font-size: 22px;
                    color: #888;
                    margin-right: 10px;
                    @include verticalAlign(sub);
                }

                &:hover {
                    opacity: 0.5;
                }
            }
        }
    }
}
</style>